import api from "@/apis/ReportListAPI";

export default {
  /**
   * Load danh sách bao cáo
   */
  async loadReportList(context, payload) {
    context.commit("updateLoading", true);

    //request
    var res = await api.load();

    context.commit("updateLoading", false);

    if (res) {
      context.commit("updateReportList", res);
    }

    return res;
  },
};
